import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bdc1f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toriokiDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ShippingHistoryDetail_Header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_HeaderTitle" })
], -1))
const _hoisted_3 = { class: "toriokiDetail_TableContainer" }
const _hoisted_4 = { class: "toriokiDetail_Table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "toriokiDetail_Table_Sticky_TH1" }, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", { class: "toriokiDetail_Table_Sticky_TH2" }, "出庫取置No"),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Large" }, "取置倉庫コード"),
    /*#__PURE__*/_createElementVNode("th", null, "取置期限"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"65px"} }, "取置理由"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"65px"} }, "取置冊数")
  ])
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "toriokiDetail_Table_Sticky_TD1" }
const _hoisted_8 = { class: "toriokiDetail_Table_Sticky_TD2" }
const _hoisted_9 = { style: {"white-space":"nowrap"} }
const _hoisted_10 = {
  key: 0,
  class: "ResultMessageNull"
}

import { ZaikoData } from "@/types/zaiko";
import axios from "axios";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

type ToriokiData = {
  janCd: string;
  toriokiNumber: string;
  toriokiSoukoCd: string;
  toriokiDeadline: string;
  reason: string;
  torioki: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ToriokiDetail',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");

const route = useRoute();
const store = useStore();

// 型
const targetCd = route.params.janCd;
const toriokiData = ref<ToriokiData[]>([]);
const headerData = ref({
  syosiCd: "",
  title: "",
  torioki: -1,
});
const getToriokiData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/torioki?janCd=${targetCd}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    // console.log(res);
    toriokiData.value = res.data;
  } catch (error) {
    alert("取り置き詳細データが取得できませんでした");
    console.log(error);
  }
};
getToriokiData();

//ヘッダ情報を抜粋して別途保持する
const getHeaderData = (datailData: ZaikoData) => {
  headerData.value = { ...datailData };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        (toriokiData.value.length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toriokiData.value, (torioki, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(torioki?.janCd), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(torioki?.toriokiNumber), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(torioki?.toriokiSoukoCd), 1),
                  _createElementVNode("td", null, _toDisplayString(torioki?.toriokiDeadline), 1),
                  _createElementVNode("td", null, _toDisplayString(torioki?.reason), 1),
                  _createElementVNode("td", null, _toDisplayString(torioki?.torioki), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!toriokiData.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 対象の取置データが見つかりませんでした。 "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})